import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { GymWrite, Gym, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateGym(): UseMutationResult<
  AxiosResponse<Gym>,
  AxiosError<ErrorMessage>,
  GymWrite
> {
  const queryClient = useQueryClient();

  const updateGym = useCallback((gym: GymWrite): Promise<AxiosResponse<Gym>> => {
    return client.put(`gyms/${gym.gymId}/`, gym);
  }, []);

  return useMutation(updateGym, {
    onSuccess: () => {
      queryClient.invalidateQueries('gyms');
    },
  });
}
